module.exports = __webpack_public_path__ + "470f39398cb9bc7814a5c6af08f66402.jpg";